import {
  Container,
  Section,
  Heading,
  Lede,
  Eyebrow,
  Card,
  LinkButton,
} from "../components/ui";
import { useSeo } from "../lib/seo";

export function Docs() {
  useSeo({
    title: "Docs — WeConsult Rx",
    description:
      "Implementation guides, API references, and onboarding documentation for WeConsult Rx.",
    path: "/docs",
  });

  return (
    <Section>
      <Container>
        <div className="max-w-3xl">
          <Eyebrow>Docs</Eyebrow>
          <Heading level={1} className="mt-3">
            Implementation guides in active development.
          </Heading>
          <Lede className="mt-6">
            Developer docs and API references are gated to active customers
            during early access. Contact us if you need credentials.
          </Lede>
          <div className="mt-8">
            <LinkButton to="/contact">Request docs access</LinkButton>
          </div>
        </div>

        <div className="mt-16 grid gap-6 md:grid-cols-3">
          {[
            ["Onboarding", "Tenant setup, user provisioning, branding."],
            ["API reference", "Fastify routes, JWT scope, RLS guarantees."],
            ["Integration playbooks", "Adobe Sign, QBO, Google + Outlook, Resend, Twilio."],
          ].map(([k, v]) => (
            <Card key={k}>
              <Heading level={3}>{k}</Heading>
              <p className="mt-3 text-ink-600">{v}</p>
            </Card>
          ))}
        </div>
      </Container>
    </Section>
  );
}
